import * as React from "react";
import { forwardRef } from "react";
const SvgNewStorage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M1 1.32907C1.42115 1.48876 6.04651 0.064769 7.87995 2.14096C9.71339 4.21715 12.5 21.5 12.5 21.5",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 1.20364,
	y: .672308,
	width: 9.85814,
	height: 5.55653,
	rx: 1,
	transform: "matrix(0.955091 -0.296312 0.248545 0.96862 12.2346 8.63507)",
	stroke: "currentColor",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("rect", {
	x: 1.20364,
	y: .672308,
	width: 15.2073,
	height: 5.55653,
	rx: 1,
	transform: "matrix(0.955091 -0.296312 0.248545 0.96862 14.5745 17.4661)",
	stroke: "currentColor",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 14,
	cy: 28,
	r: 3,
	stroke: "currentColor",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 14,
	cy: 28,
	r: .9,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: .2
}), /* @__PURE__ */ React.createElement("line", {
	x1: 1,
	y1: -1,
	x2: 12.1218,
	y2: -1,
	transform: "matrix(0.957322 -0.289023 0.242263 0.970211 19.6621 27.1714)",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgNewStorage);
export default ForwardRef;
